import { REPORTS_STOCK_AUDIT } from "../../framework/tab/tabUtilsConstants";
import moment from "moment";
import { dateFilterComparator } from "../../utils/utils";
export const columnDefs = [
  {
    headerName: "Stock Audit Request ID",
    field: "stockAuditRequestId",
    width: 150,
  },
  {
    headerName: "Stock Audit ID",
    field: "stockAuditId",
    width: 150,
  },
  {
    headerName: "Branch Code",
    field: "branchCode",
    width: 150,
  },
  {
    headerName: "Branch Name",
    field: "branchName",
    width: 150,
  },
  {
    headerName: "Company",
    field: "company",
    width: 150,
  },
  {
    headerName: "Auditor",
    field: "auditor",
    width: 150,
  },
  {
    headerName: "Stock Audit Status",
    field: "stockAuditStatus",
    width: 150,
  },
  {
    headerName: "Created Time",
    field: "createdTime",
    width: 150,
  },
  {
    headerName: "Audit Business Time",
    field: "stockAuditbusinessTime",
    width: 150,
  },
  {
    headerName: "Number of Items",
    field: "numberOfItems",
    width: 150,
  },
  {
    headerName: "Admin Remarks",
    field: "remarks",
    width: 150,
  },
  {
    headerName: "Auditor Remarks",
    field: "auditorRemarks",
    width: 150,
  },
];
export const columnDefsFunctions = {
  createdTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  stockAuditbusinessTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
};

export const initial_state_stock_audit_report = {
  type: REPORTS_STOCK_AUDIT,
  label: "Stock Audit Report",
  allowMultipleTabs: false,
};
